import { render, staticRenderFns } from "./ItemInformation.vue?vue&type=template&id=38df1f59&scoped=true&"
import script from "./ItemInformation.vue?vue&type=script&lang=js&"
export * from "./ItemInformation.vue?vue&type=script&lang=js&"
import style0 from "./ItemInformation.vue?vue&type=style&index=0&id=38df1f59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38df1f59",
  null
  
)

export default component.exports